module.exports = __webpack_public_path__ + "static/media/app_icon_trans.e683e32b.png";